<template>
  <p>{{ time }}</p>
</template>

<script>
  export default {
    props: {
      endTime: {
        type: [String, Number],
        default: '',
      },
      type: {
        type: Number,
        default: 0,
      },
    },

    data() {
      return {
        time: '',
        isTimeout: false,
        timer: null,
      };
    },
    watch: {
      endTime: {
        handler() {
          clearInterval(this.timer);
          this.timer = setInterval(() => {
            if (this.isTimeout) {
              clearInterval(this.timer);
            }
            this.timeDown();
          }, 500);
        },
        immediate: true,
      },
    },
    beforeDestroy() {
      clearInterval(this.timer);
    },
    // mounted() {
    //   this.timer = setInterval(() => {
    //     if (this.isTimeout) {
    //       clearInterval(this.timer);
    //     }
    //     this.timeDown();
    //   }, 500);
    // },
    methods: {
      timeDown() {
        if (!this.endTime) {
          this.time = '';
          return;
        }
        const endTime = new Date(this.endTime);
        const nowTime = new Date();
        let leftTime = endTime - nowTime.getTime();
        if (leftTime <= 0) {
          this.time = '已超时';
          this.isTimeout = true;
        } else {
          leftTime = Math.abs(leftTime);
          if (this.type === 1) {
            const second = 1000;
            const minute = second * 60;
            const hour = minute * 60;
            const day = hour * 24;
            const days = Math.floor(leftTime / day);
            const hours = Math.floor((leftTime % day) / hour);
            const minutes = Math.floor((leftTime % hour) / minute);
            const seconds = Math.floor((leftTime % minute) / second);
            this.time = `${days}天${hours}小时${minutes}分${seconds}秒`;
          } else {
            const h = this.formate(Math.floor(leftTime / 1000 / 60 / 60));
            const m = this.formate(Math.floor(leftTime / 1000 / 60 % 60));
            const s = this.formate(Math.floor(leftTime / 1000 % 60));
            this.time = `${h}:${m}:${s}`;
          }
        }
      },
      formate(time) {
        if (time >= 10) {
          return time;
        }
        return `0${time}`;
      },
    },
  };
</script>
